import "./lightLoader.css";

const LightLoader = () => {
	return (
		<div className="light-loader-container">
			<div className="light-loader"></div>
		</div>
	);
};

export default LightLoader;
